import { HttpInterceptorFn } from "@angular/common/http";

import { SKIP_AUTH0 } from "../tokens/http-context.tokens";

import { environment } from "../../../environments/environment";

export const autosyncInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_AUTH0)) {
    const cloneReq = req.clone({
      setHeaders: {
        "x-api-key": environment.AUTOSYNC.TOKEN,
      },
    });
    return next(cloneReq);
  }

  return next(req);
};
